import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import type { FertilizationPlanReferenceDTO, FertilizationPlanReferencePayload } from './types';

export const useUpdateFertilizationPlanReference = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ id, data: payload }: { id: string; data: Partial<FertilizationPlanReferencePayload> }) => {
			try {
				const { data } = await api.put<FertilizationPlanReferenceDTO>(
					`/fertilization-plan-reference/update/${id}`,
					payload,
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar referência do plano');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fertilization-plan-reference'] }),
		onError: error =>
			console.error(
				'Erro ao atualizar referência do plano:',
				getApiErrorMessage(error, 'Erro ao atualizar referência do plano'),
			),
	});
};
